/**
 * 移动端导航栏
 */
import styles from './index.module.scss'
import {Items} from '../../consts/Menu.ts';
import { APP_URL } from '../../consts/Links.ts';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import React from 'react'

const MobileMenu = ({ isMenu,setMenu }) => {
 const location = useLocation();
 const pathname = location.pathname

 const value = pathname?.startsWith('/') ? pathname.slice(1) : pathname;
 const navigate = useNavigate();

 const onClick = (e) => {

  window.scrollTo(0, 0)
  if (e.url?.startsWith('http')) {
   window.open(e.url, '_blank')
  }else if (e.url?.startsWith('/')&&!e.children) {
   console.log(e)
   navigate(e.url)
  }
  setMenu(false)
 };
 return (
   <>
    {
     isMenu?(
       <div className={`${styles.menuWrap} absolute`} onClick={()=>setMenu(false)}>
        <div className={`${styles.menu} absolute`}>
         {
          Items.map((item, index) => (
            <div className="ant-menu-item" key={index}>
             <div className="ant-menu-title-content" onClick={() => onClick(item)}>{item.label}</div>
             {
              item?.children ? (
                <div className="ant-menu-submenu" key={index}>
                 {
                  item?.children?.map((item2, index2) => (
                    <div className="ant-menu-submenu-item" key={index2}>
                     <div className="ant-menu-title-content" onClick={() => onClick(item2)}>{item2.label}</div>
                    </div>
                  ))
                 }
                </div>
              ) : null
             }
            </div>
          ))
         }
         <Link target="_blank" to={APP_URL}>
          <button className={`${styles.defiLlamButton}`} style={{marginLeft: '0'}}>Launch App</button>
         </Link>
         <Link target="_blank" to="https://defillama.com/protocol/vishwa">
          <button className={`${styles.defiLlamButton}`} style={{marginLeft: '0'}}>Vishwa Stats</button>
         </Link>
        </div>
       </div>
     ) : null
    }
   </>
 )
}

export default MobileMenu;